const { default: axios } = require("axios");
const { default: UtilitiesUP } = require("./utilities");
const { contains } = require("jquery");


//http://maps.google.com/maps?q=50.3404166,15.9333541


const GeoLocation = function () {

    const getDistanceFromLatLonInKm = function (lat1,lon1,lat2,lon2) {
		var R = 6371; // Radius of the earth in km
		var dLat = deg2rad(lat2-lat1);  // deg2rad below
		var dLon = deg2rad(lon2-lon1); 
		var a = 
		  Math.sin(dLat/2) * Math.sin(dLat/2) +
		  Math.cos(deg2rad(lat1)) * Math.cos(deg2rad(lat2)) * 
		  Math.sin(dLon/2) * Math.sin(dLon/2)
		  ; 
		var c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1-a)); 
		var d = R * c; // Distance in km
		return d;
    }
	  
    const deg2rad = function (deg) {
        return deg * (Math.PI/180)
    }
	
    const getLocation = function () {
        if (navigator.geolocation) {
            navigator.geolocation.getCurrentPosition(ajaxPosition);
        } else {
            // x.innerHTML = "Geolocalização não é suportada por esse navegador.";

        }
    }
	  
    function showPosition(position) {
        const x = document.getElementById("demo");
        
		x.innerHTML = "Latitude: " + position.coords.latitude +
		"<br>Longitude: " + position.coords.longitude + "<br>Distância: " +  getDistanceFromLatLonInKm(position.coords.latitude,position.coords.longitude,-23.464648, -46.543402).toFixed(1) + " km";
    }

    function ajaxPosition(position) {
        
        var url = $('.store-geolocation').data('ajax');

        axios.post(url, {
            latitude: position.coords.latitude,
            longitude: position.coords.longitude,
            location_type_id: $('.store-geolocation').data('location_type_id')
        }).then(response => {
            const data = response.data;

            if (data.error === false) {
                // console.log(data.result)
            }else{
                // const classUtilitites = new UtilitiesUP;
                // classUtilitites.showAlert(data.message, "Ok");
            }

        })
        .catch(function (error) {
            // const classUtilitites = new UtilitiesUP;
            // classUtilitites.showAlert("Erro de comunicação, por favor, recarregue a página", "Ok");
        });


		
        
    }

    return {
        init: function () {
            
            if ($('.store-geolocation').length > 0) {
                getLocation()
            }
            
        }
    }
    
}();

module.exports = GeoLocation